import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import toastr from "toastr";
import {
  editCampaña,
  saveCampaña,
} from "../../redux/climalaboral/campaña/action";
import { useDispatch, useSelector } from "react-redux";
import MultiselectFormik from "../MultiselectFormik";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Typeahead } from "react-bootstrap-typeahead";
import { getPlantillaCuestionarios } from "../../redux/climalaboral/plantillaCuestionario/action";
import { LensTwoTone } from "@material-ui/icons";

const returnData = (value) => {
  var _list = [];
  value.map((item) => {
    _list = [
      ..._list,
      { value: item.id, label: item.first_name + " " + item.last_name },
    ];
  });
  return _list;
};

const ModalCampaign = (props) => {
  const [segmentSelected, setSegmentSelected] = useState([]);

  const option = [
    { value: true, label: "Activo" },
    { value: false, label: "Inactivo" },
  ];

  const schema = Yup.object().shape({
    nombre_campaña: Yup.string().ensure().required("**Campo requerido"),
    // segmento: Yup.string().ensure().required("**Campo requerido"),
    tipo_herramienta: Yup.string().ensure().required("**Campo requerido"),
    cuestionario: Yup.string().ensure().required("**Campo requerido"),
    activa: Yup.string().ensure().required("**Campo requerido"),
    responsable: Yup.array().test({
      message: "**Campo requerido",
      test: (val) => val.length !== 0,
    }),
    fecha_inicio: Yup.string().ensure().required("**Campo requerido"),
    fecha_fin: Yup.string().ensure().required("**Campo requerido"),
  });

  const [validated, setValidated] = useState(false);

  const { segment: segmento, loading: segmentoLoading } = useSelector(
    (store) => store.segment
  );

  const { responsable, responsablesLoading } = useSelector(
    (store) => store.campaña
  );

  const { tool: herramientas, loading: herramientasLoading } = useSelector(
    (store) => store.tool
  );

  const { surveyTemplate, surveyLoading } = useSelector(
    (store) => store.plantillaCuestionario
  );

  const { username } = useSelector((store) => store.auth);

  const { saveLoading } = useSelector((store) => store.campaña);

  const dispatch = useDispatch();
  const history = useHistory();

  let campaignsOptions = [];
  surveyTemplate &&
    surveyTemplate.data
      .sort((a, b) => {
        if (a.nombre && b.nombre) {
          if (a.nombre.toLowerCase() === b.nombre.toLowerCase()) {
            return 0;
          }
          if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
            return -1;
          }
        }
        return 1;
      })
      .map((item) => {
        campaignsOptions = [
          ...campaignsOptions,
          {
            id: item.id,
            label: item.nombre.toUpperCase(),
          },
        ];
      });

  useEffect(() => {
    dispatch(getPlantillaCuestionarios({}));
  }, []);

  const onSubmit = (_req) => {
    let req = _req;
    if (moment(req.fecha_inicio) > moment(req.fecha_fin)) {
      toastr.info("La fecha inicio no pueder ser mayor a la fecha fin");
      return;
    }
    let dataRespT = [];
    req.responsable.map((item) => {
      dataRespT = [...dataRespT, item.value];
    });
    req.responsable = dataRespT;

    if (!props.edit) {
      dispatch(
        saveCampaña(
          req,
          props.setShowModal,
          props.maintenance,
          history,
          username
        )
      );
    } else {
      dispatch(
        editCampaña(req, props.editItem.id, props.index, props.setShowModal)
      );
    }
  };
  return (
    <>
      <Modal
        size="lg"
        show={props.showModal}
        onHide={() => {
          props.setShowModal(false);
        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre_campaña: props.edit ? props.editItem.nombre_campaña : "",
            // segmento: props.edit ? props.editItem.segmento : "",
            tipo_herramienta: props.edit ? props.editItem.tipo_herramienta : "",
            cuestionario: props.edit ? props.editItem.cuestionario : "",
            activa: props.edit ? props.editItem.activa : option[0].value,
            responsable:
              props.edit && props.editItem.responsable_list
                ? returnData(props.editItem.responsable_list)
                : [],
            fecha_inicio: props.edit ? props.editItem.fecha_inicio : "",
            fecha_fin: props.edit ? props.editItem.fecha_fin : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {props.edit ? "Editar campaña" : "Crear campaña"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="d-flex align-items-center">
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Nombre de campaña:
                    </Form.Label>
                    <Form.Control
                      name="nombre_campaña"
                      className="rounded-pill"
                      type="text"
                      value={values.nombre_campaña}
                      onBlur={handleBlur("nombre_campaña")}
                      onChange={handleChange}
                      isInvalid={
                        touched.nombre_campaña && !!errors.nombre_campaña
                      }
                      isValid={touched.nombre_campaña && !errors.nombre_campaña}
                      placeholder="Nombre de la campaña"
                    ></Form.Control>
                    {touched.nombre_campaña && errors.nombre_campaña && (
                      <div>
                        <small className="text-danger px-2">
                          {errors.nombre_campaña}
                        </small>
                      </div>
                    )}
                  </Form.Group>
                </Row>
                {/* <Row>
                  <Form.Group as={Col}>
                    <Form.Label column className="ml-2">
                      Segmento
                    </Form.Label>
                    <Row className="d-flex align-items-center">
                      <Col sm={segmentoLoading ? "10" : "12"}>
                        <Form.Control
                          name="segmento"
                          className="rounded-pill"
                          as="select"
                          value={values.segmento}
                          onBlur={handleBlur("segmento")}
                          onChange={handleChange}
                          isInvalid={touched.segmento && !!errors.segmento}
                          isValid={touched.segmento && !errors.segmento}
                        >
                          <option value="" disabled selected>
                            Seleccione un segmento
                          </option>
                          {segmento.map((segment) => (
                            <option value={segment.id}>{segment.nombre}</option>
                          ))}
                        </Form.Control>
                        {touched.segmento && errors.segmento && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.segmento}
                            </small>
                          </div>
                        )}
                      </Col>
                      {segmentoLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label column className="ml-2">
                      Responsable
                    </Form.Label>
                    <Row className="d-flex align-items-center">
                      <Col sm={responsablesLoading ? "10" : "12"}>
                        <MultiselectFormik
                          id="responsable"
                          name="responsable"
                          options={responsable ? returnData(responsable) : []}
                          value={values.responsable}
                          onChange={(selected) => {
                            setFieldValue(
                              "responsable",
                              selected.length > 0 ? selected : []
                            );
                          }}
                          isValid={touched.responsable && !errors.responsable}
                          isInvalid={touched.responsable && errors.responsable}
                          onBlur={() => handleBlur("responsable")}
                        />
                        {touched.responsable && errors.responsable && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.responsable}
                            </small>
                          </div>
                        )}
                      </Col>
                      {responsablesLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                </Row> */}
                <Row>
                  <Form.Group as={Col}>
                    <Form.Label column className="ml-2">
                      Responsable
                    </Form.Label>
                    <Row className="d-flex align-items-center">
                      <Col sm={responsablesLoading ? "10" : "12"}>
                        <MultiselectFormik
                          id="responsable"
                          name="responsable"
                          options={responsable ? returnData(responsable) : []}
                          value={values.responsable}
                          onChange={(selected) => {
                            setFieldValue(
                              "responsable",
                              selected.length > 0 ? selected : []
                            );
                          }}
                          isValid={touched.responsable && !errors.responsable}
                          isInvalid={touched.responsable && errors.responsable}
                          onBlur={() => handleBlur("responsable")}
                        />
                        {touched.responsable && errors.responsable && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.responsable}
                            </small>
                          </div>
                        )}
                      </Col>
                      {responsablesLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label column className="ml-2">
                      Tipo de Herramienta
                    </Form.Label>
                    <Row className="d-flex align-items-center">
                      <Col sm={herramientasLoading ? "10" : "12"}>
                        <Form.Control
                          name="tipo_herramienta"
                          className="rounded-pill"
                          as="select"
                          value={values.tipo_herramienta}
                          onBlur={handleBlur("tipo_herramienta")}
                          onChange={handleChange}
                          isInvalid={
                            touched.tipo_herramienta &&
                            !!errors.tipo_herramienta
                          }
                          isValid={
                            touched.tipo_herramienta && !errors.tipo_herramienta
                          }
                        >
                          <option value="" disabled selected>
                            Seleccione un tipo de herramienta
                          </option>
                          {herramientas.map((tool) => (
                            <option value={tool.id}>{tool.nombre}</option>
                          ))}
                        </Form.Control>
                        {touched.tipo_herramienta &&
                          errors.tipo_herramienta && (
                            <div>
                              <small className="text-danger px-2">
                                {errors.tipo_herramienta}
                              </small>
                            </div>
                          )}
                      </Col>
                      {herramientasLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label column className="ml-2">
                      Cuestionario
                    </Form.Label>
                    <Row className="d-flex align-items-center">
                      <Col sm={surveyLoading ? "10" : "12"}>
                        {!props.edit ? (
                          <>
                            <Typeahead
                              id="cuestionario"
                              name="cuestionario"
                              isInvalid={
                                touched.cuestionario && errors.cuestionario
                              }
                              isValid={
                                touched.cuestionario && !errors.cuestionario
                              }
                              onBlur={handleBlur("cuestionario")}
                              placeholder="Seleccione un cuestionario"
                              options={campaignsOptions}
                              onChange={(selected) => {
                                setFieldValue(
                                  "cuestionario",
                                  selected.length > 0 ? selected[0].id : ""
                                );
                                setSegmentSelected(selected);
                              }}
                              selected={segmentSelected}
                              disabled={surveyLoading}
                            ></Typeahead>
                            {/* <Form.Control
                              name="cuestionario"
                              className="rounded-pill"
                              as="select"
                              value={values.cuestionario}
                              onBlur={handleBlur("cuestionario")}
                              onChange={handleChange}
                              isInvalid={
                                touched.cuestionario && !!errors.cuestionario
                              }
                              isValid={
                                touched.cuestionario && !errors.cuestionario
                              }
                            >
                              <option value="" disabled selected>
                                Seleccione un cuestionario
                              </option>
                              {cuestionarioss
                                ? cuestionarioss
                                    .sort((a, b) => {
                                      if (a.nombre && b.nombre) {
                                        if (
                                          a.nombre.toLowerCase() ===
                                          b.nombre.toLowerCase()
                                        ) {
                                          return 0;
                                        }
                                        if (
                                          a.nombre.toLowerCase() <
                                          b.nombre.toLowerCase()
                                        ) {
                                          return -1;
                                        }
                                      }
                                      return 1;
                                    })
                                    .map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.nombre
                                          ? item.nombre.toUpperCase()
                                          : ""}
                                      </option>
                                    ))
                                : null}
                            </Form.Control> */}
                            {touched.cuestionario && errors.cuestionario && (
                              <div>
                                <small className="text-danger px-2">
                                  {errors.cuestionario}
                                </small>
                              </div>
                            )}
                          </>
                        ) : (
                          <Form.Control
                            className="rounded-pill"
                            type="text"
                            disabled
                            readOnly
                            value={props.editItem.cuestionario_list.nombre}
                          />
                        )}
                      </Col>
                      {!props.edit && surveyLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col}>
                    <Form.Label className="ml-2">Fecha de inicio</Form.Label>
                    <Form.Control
                      id="fecha_inicio"
                      name="fecha_inicio"
                      isInvalid={
                        (touched.fecha_inicio && errors.fecha_inicio) ||
                        (touched.fecha_inicio &&
                          values.fecha_inicio !== "" &&
                          values.fecha_fin !== "" &&
                          moment(values.fecha_inicio) >
                            moment(values.fecha_fin))
                      }
                      isValid={
                        (touched.fecha_inicio && !errors.fecha_inicio) ||
                        (touched.fecha_inicio &&
                          !(
                            values.fecha_inicio !== "" &&
                            values.fecha_fin !== "" &&
                            moment(values.fecha_inicio) >
                              moment(values.fecha_fin)
                          ))
                      }
                      onBlur={handleBlur("fecha_inicio")}
                      onChange={handleChange}
                      value={values.fecha_inicio}
                      type="date"
                      className="rounded-pill"
                    />
                    {touched.fecha_inicio && !!errors.fecha_inicio && (
                      <div className="px-2">
                        <small className="text-danger">
                          {errors.fecha_inicio}
                        </small>
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label className="ml-2">Fecha final</Form.Label>
                    <Form.Control
                      id="fecha_fin"
                      name="fecha_fin"
                      isInvalid={
                        (touched.fecha_fin && errors.fecha_fin) ||
                        (touched.fecha_fin &&
                          values.fecha_inicio !== "" &&
                          values.fecha_fin !== "" &&
                          moment(values.fecha_inicio) >
                            moment(values.fecha_fin))
                      }
                      isValid={
                        (touched.fecha_fin && !errors.fecha_fin) ||
                        (touched.fecha_fin &&
                          !(
                            values.fecha_inicio !== "" &&
                            values.fecha_fin !== "" &&
                            moment(values.fecha_inicio) >
                              moment(values.fecha_fin)
                          ))
                      }
                      onBlur={handleBlur("fecha_fin")}
                      onChange={handleChange}
                      value={values.fecha_fin}
                      type="date"
                      className="rounded-pill"
                    />
                    {touched.fecha_fin && !!errors.fecha_fin && (
                      <div className="px-2">
                        <small className="text-danger">
                          {errors.fecha_fin}
                        </small>
                      </div>
                    )}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col}>
                    <Row className="align-items-end">
                      <Col sm="12" md="6">
                        <Form.Label className="ml-2">Activo</Form.Label>
                        <Form.Control
                          name="activa"
                          className="rounded-pill"
                          as="select"
                          value={values.activa}
                          onBlur={handleBlur("activa")}
                          onChange={handleChange}
                          isInvalid={touched.activa && !!errors.activa}
                          isValid={touched.activa && !errors.activa}
                        >
                          {option.map((option) => (
                            <option value={option.value}>{option.label}</option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => props.setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default ModalCampaign;
